<template>
  <div class="highlighter-wrapper relative d-flex flex-grow-1 flex-wrap">
    <document-viewer
      v-if="!documentParsedDetails.isLoading"
      :document="document"
      :rotation="rotation"
      :overlays="documentParsedDetailBoundingBoxes"
      :show-page-check-signals="false"
      @rotate="$emit('rotate')"
    />
    <div v-else class="d-flex w-100 align-items-center justify-content-center">
      <i-spinner></i-spinner>
    </div>
  </div>
</template>

<script>
import DocumentViewer from './DocumentViewer';
import { iSpinner } from '@inscribe/signal';

export default {
  components: {
    'document-viewer': DocumentViewer,
    iSpinner,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    rotation: {
      type: Number,
      required: true,
    },
  },
  computed: {
    documentParsedDetails() {
      return this.$store.state.documentParsedDetailsHighlighter;
    },
    documentParsedDetailBoundingBoxes() {
      if (this.documentParsedDetails.isLoading) {
        return [];
      }

      return this.documentParsedDetails.documents[this.document.id];
    },
  },
  watch: {
    documentParsedDetailBoundingBoxes: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          setTimeout(() => {
            this.scrollToFirstBoundingBox();
          }, 500);
        }
      },
      deep: true,
    },
  },
  created() {
    this.getParsedDetailsBoundingBoxes();
    if (this.$route.query.bounding_box_ids) {
      this.scrollToFirstBoundingBoxWhenReady();
    }
  },
  methods: {
    async scrollToFirstBoundingBoxWhenReady() {
      let max_tries = 30;
      while (max_tries > 0) {
        const genericOverlays = document.querySelectorAll('.generic-overlays');
        if (genericOverlays.length > 0) {
          setTimeout(() => {
            this.scrollToFirstBoundingBox();
          }, 500);
          break;
        }
        await new Promise((resolve) => setTimeout(resolve, 250));
        max_tries--;
      }
    },
    getParsedDetailsBoundingBoxes() {
      this.$store.commit('setParsedDetailsHighlighterLoading', true);
      this.$store
        .dispatch('getParsedDetailsHighlighterBoundingBoxes', {
          customerId: this.document.customer_id,
          documentId: this.document.id,
          boundingBoxIds: this.$route.query.bounding_box_ids,
        })
        .then(() => {
          this.$store.commit('setParsedDetailsHighlighterLoading', false);
        });
    },
    scrollToFirstBoundingBox() {
      const genericOverlays = document.querySelectorAll('.generic-overlays');
      let firstOverlay = null;
      let lowestTopValue = Infinity;

      genericOverlays.forEach((overlayContainer) => {
        const overlays = overlayContainer.querySelectorAll(':scope > .overlay');

        overlays.forEach((overlay) => {
          const topValue = parseFloat(overlay.style.top);

          if (!isNaN(topValue) && topValue < lowestTopValue) {
            lowestTopValue = topValue;
            firstOverlay = overlay;
          }
        });
      });

      if (firstOverlay) {
        firstOverlay.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.highlighter-wrapper {
  max-height: 100%;
  overflow: auto;
}
</style>
